var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvalaplain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_evalalogo",
    d: "M25.483 6.955c-4.662 2.97-8.535 7.29-10.719 12.395-.793 1.855-1.043 5.004 1.602 5.445 1.026.171 2.285-.212 3.259-.481 1.249-.346 2.464-.869 3.505-1.648.731-.547 1.617-1.254 1.758-2.217.145-.998-.467-1.784-1.464-1.936-1.041-.158-1.98.499-2.801 1.051a16.853 16.853 0 00-2.923 2.494 17.072 17.072 0 00-3.766 6.441c-.579 1.826-1.129 4.328.127 6.015 1.67 2.244 4.68.636 6.358-.721 2.434-1.968 4.355-4.581 6.344-6.972.511-.614-.369-1.503-.884-.884-1.189 1.43-2.356 2.862-3.604 4.243-1.285 1.423-2.613 2.921-4.371 3.765-1.034.496-2.321.75-2.978-.396-.37-.644-.393-1.475-.338-2.196.137-1.815.854-3.671 1.723-5.251a16.034 16.034 0 013.326-4.195 14.705 14.705 0 012.24-1.66c.503-.304 2.072-.859 1.628.232-.206.507-.722.905-1.153 1.22-1.449 1.059-3.451 1.725-5.244 1.854-3.339.241-.842-4.587-.113-5.893 2.186-3.92 5.338-7.216 9.119-9.624.676-.433.05-1.515-.631-1.081z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvalaplain);
export default __webpack_public_path__ + "static/media/evala.plain.3c39c06381827695ec467d9b161b450e.svg";
export { ForwardRef as ReactComponent };